module.exports = __webpack_public_path__ + "514f68997ee00f505419aa08c38855e2.png";